<script setup>
import ModuleBreadcrumb from "~/components/product/ModuleBreadcrumb.vue";
import ModuleProductViewer from "~/components/product/ModuleProductViewer.vue";
import ModuleProductTitle from "~/components/product/ModuleProductTitle.vue";
import ModuleProductRate from "~/components/product/ModuleProductRate.vue";
import ModuleProductInfo from "~/components/product/ModuleProductInfo.vue";
import ModuleProductSize from "~/components/product/ModuleProductSize.vue";
import ModuleProductActionButton from "~/components/product/ModuleProductActionButton.vue";
import ModuleProductDescription from "~/components/product/ModuleProductDescription.vue";
import ModuleProductSuitableDressing from "~/components/product/ModuleProductSuitableDressing.vue";
import ModuleProductRateLarge from "~/components/product/ModuleProductRateLarge.vue";
import ModuleProductReviews from "~/components/product/ModuleProductReviews.vue";
import ModuleCarouselCount6 from "~/components/ModuleCarouselCount6.vue";
import ModuleCarouselCount6Skeleton from "~/components/ModuleCarouselCount6Skeleton.vue";
import {useBaseStore} from "~/stores/base";
import {useProductStore} from "~/stores/product";
import {productConfig, productInfo, productReviewRecommendList} from "~/api/api.product";
import {
  basicProductListByRecentlyViewed,
  basicProductListBySimilarItems,
  basicProductListByYouLike
} from "~/api/api.basic";
import {wishlistList} from "~/api/api.wishlist";
import _ from 'lodash'
import {PAGE_LABEL} from "~/utils/smartlook";
import {convert} from "html-to-text";
import {googleTrackViewProduct} from "~/utils/google-track";
import ModuleProductSizeRange from "~/components/product/ModuleProductSizeRange.vue";
import {shareInfo} from "~/api/api.share";
import {voteDetail} from "~/api/api.vote";

const router = useRouter()
const route = useRoute()
const slug = route.params.slug // `slug` 是一个数组

// 根据 slug 数组的长度来判断访问的路由格式
let id = null
let productHandle = null

if (slug.length === 1) {
  // 访问 `/product/1695133554978787329`
  id = slug[0]
} else {
  // 访问 `/product/1695133554978787329/[HASH]`
  id = slug[0]
  productHandle = slug.slice(1, 2)
}
console.log('[productHandle]', productHandle)
// 可以根据 `productHandle` 和 `id` 来加载对应的页面内容

/** data **/
const product = ref({})
const pageIndexReviews = ref(1)
const pageSizeReviews = ref(20)
const reviews = ref([])
const fitInfo = ref({})
const currentColorIndex = ref(0)
const currentSku = ref("")

const isSimilarItemsLoading = ref(false)
const isRecentlyViewedLoading = ref(false)
const isYouMayAlsoLikeLoading = ref(false)
const isWishListLoading = ref(false)
const similarItems = ref([])
const recentlyViewed = ref([])
const youLike = ref([])
const wishlist = ref([])

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const isLogin = computed(() => useBaseStore().getterIsLogin)
const query = computed(() => route.query)

/** watch **/
watch(query, () => {
  // 监听投票
  if (query.value.voteId) {
    getVoteResult()
  } else {
    resetVoteInfo()
  }
})

/** methods **/
const getProductInfo = async () => {
  try {
    const {data: productRes} = await useAsyncData(() => productInfo({id}))
    console.log("productInfo", productRes.value)
    useProductStore().updateProductIdLastVisit(id)
    if (!productRes.value) return router.replace("/404")
    product.value = productRes.value.result
    if (_.isEmpty(product.value)) return router.replace("/404")
  } catch (e) {
    console.error(e)
  }
}
const getProductConfig = async () => {
  try {
    const {data: configRes} = await useAsyncData(() => productConfig({shopProductId: id}))
    console.log("productConfig", configRes.value)
    useProductStore().updateProductConfig(configRes.value.result)
  } catch (e) {
    console.error(e)
  }
}
const getReviews = async () => {
  try {
    const reviewsRes = await productReviewRecommendList({
      id,
      pageIndex: pageIndexReviews.value,
      pageSize: pageSizeReviews.value,
    })
    console.log("reviews", reviewsRes)
    reviews.value = reviewsRes.result.list || []
    fitInfo.value = reviewsRes.result.info || {}
  } catch (e) {
    console.error(e)
  }
}
const getSimilarItems = async () => {
  isSimilarItemsLoading.value = true
  try {
    const similarItemsRes = await basicProductListBySimilarItems({
      productId: id,
      pageIndex: 1,
      pageSize: 18
    })
    console.log("similarItems", similarItemsRes)
    similarItems.value = similarItemsRes.result.list || []
    isSimilarItemsLoading.value = false
  } catch (e) {
    isSimilarItemsLoading.value = false
    console.error(e)
  }
}
const getRecentlyViewed = async () => {
  isRecentlyViewedLoading.value = true
  try {
    const recentlyViewedRes = await basicProductListByRecentlyViewed({
      productId: id,
      pageIndex: 1,
      pageSize: 18
    })
    console.log("recentlyViewed", recentlyViewedRes)
    recentlyViewed.value = recentlyViewedRes.result.list || []
    isRecentlyViewedLoading.value = false
  } catch (e) {
    isRecentlyViewedLoading.value = false
    console.error(e)
  }
}
const getYouLike = async () => {
  isYouMayAlsoLikeLoading.value = true
  try {
    const youLikeRes = await basicProductListByYouLike({
      productId: id,
      pageIndex: 1,
      pageSize: 18
    })
    console.log("youLike", youLikeRes)
    youLike.value = youLikeRes.result.list || []
    isYouMayAlsoLikeLoading.value = false
  } catch (e) {
    isYouMayAlsoLikeLoading.value = false
    console.error(e)
  }
}
const getWishlist = async () => {
  isWishListLoading.value = true
  try {
    const wishlistRes = await wishlistList({
      pageIndex: 1,
      pageSize: 18
    })
    console.log("wishlist", wishlistRes)
    wishlist.value = wishlistRes.result.list || []
    isWishListLoading.value = false
  } catch (e) {
    isWishListLoading.value = false
    console.error(e)
  }
}
const handleColorChange = (index) => {
  console.log("handleColorChange", index)
  currentColorIndex.value = index
  currentSku.value = ""
}
const handleSizeChange = (sku) => {
  console.log("handleSizeChange", sku)
  currentSku.value = sku
}
const getVoteResult = async () => {
  const res = await voteDetail({shareId: query.value.voteId, shopProductId: id})
  useProductStore().updateVoteRole(res.result.voteRole)
  const {senderInfo: creatorInfo, receiverInfo: playerInfo} = res.result
  switch (res.result.voteRole) {
    case 1:
      useProductStore().updateVoteData(creatorInfo)
      useProductStore().updateIsShowDrawerProductVoteCreator(true)
      break;
    case 2:
      useProductStore().updateVoteData(playerInfo)
      useProductStore().updateIsShowDrawerProductVotePlayer(true)
      break;
  }
}
const resetVoteInfo = () => {
  useProductStore().updateVoteRole(0)
  useProductStore().updateVoteData({})
  useProductStore().updateIsShowDrawerProductVoteCreator(false)
  useProductStore().updateIsShowDrawerProductVotePlayer(false)
}
const getSEOInfo = async () => {
  try {
    const {data} = await useAsyncData(() => shareInfo({shareId: query.value.voteId}))
    return data.value.result
  } catch (e) {
    console.error(e)
  }
}

/** lifecycle **/
try {
  await getProductInfo()
  await getProductConfig()

  /** for SEO **/
  let ogImage = product.value.optionConfig[0].imageSets[0].url
  if (query.value.voteId) {
    const {previewImage} = await getSEOInfo()
    ogImage = previewImage.url
  }
  useSeoMeta({
    title: product.value.title + " | BNTO",
    ogTitle: product.value.title + " | BNTO",
    description: convert(product.value.description),
    ogDescription: convert(product.value.description),
    ogImage,
    ogType: "product"
  })
} catch (e) {
  // 兼容商品下架
}

onMounted(() => {
  googleTrackViewProduct(product.value)
  useBaseStore().updatePageLabel(PAGE_LABEL.PRODUCT_DETAIL)
  getReviews()
  getSimilarItems()
  isLogin.value && getRecentlyViewed()
  isLogin.value && getYouLike()
  isLogin.value && getWishlist()

  /** 打开投票窗口 **/
  if (query.value.voteId) {
    getVoteResult()
  }
})
onActivated(() => {
  useBaseStore().updatePageLabel(PAGE_LABEL.PRODUCT_DETAIL)
})
</script>

<template>
  <div class="product-content-mobile" v-if="isMobile">
    <module-product-viewer :product="product" :current="currentColorIndex"/>
    <module-product-title :product="product"/>
    <module-product-rate :product="product" v-if="product.reviewCount"/>
    <module-product-info :product="product" :sku="currentSku" @change="handleColorChange"/>
    <module-product-size v-if="isLogin" :product="product" :current-color-index="currentColorIndex" :current-sku="currentSku" @change="handleSizeChange"/>
    <module-product-size-range v-else :product="product" :current-color-index="currentColorIndex"/>
    <module-product-description :product="product"/>
    <module-product-suitable-dressing :product="product" :current="currentColorIndex"/>
    <div v-if="fitInfo.reviewCount">
      <div class="title">reviews</div>
      <module-product-rate-large :fit-info="fitInfo"/>
      <module-product-reviews :reviews="reviews"/>
    </div>
    <module-carousel-count6-skeleton v-if="isSimilarItemsLoading"/>
    <module-carousel-count6
      v-else-if="!isSimilarItemsLoading && similarItems.length"
      :title="'similar items'"
      :list="similarItems"
    />
    <module-carousel-count6-skeleton v-if="isRecentlyViewedLoading"/>
    <module-carousel-count6
      v-else-if="!isRecentlyViewedLoading && isLogin && recentlyViewed.length"
      :title="'recently viewed'"
      :list="recentlyViewed"
    />
    <module-carousel-count6-skeleton v-if="isYouMayAlsoLikeLoading"/>
    <module-carousel-count6
      v-else-if="!isYouMayAlsoLikeLoading && isLogin && youLike.length"
      :title="'you may also like'"
      :list="youLike"
    />
    <module-carousel-count6-skeleton v-if="isWishListLoading"/>
    <module-carousel-count6
      v-else-if="!isWishListLoading && isLogin && wishlist.length"
      :title="'wishlist'"
      :list="wishlist"
    />
    <div class="footer">
      <module-product-action-button :product="product" :sku="currentSku"/>
    </div>
  </div>
  <div class="product-content-desktop" v-else>
    <module-breadcrumb :product="product"/>
    <div class="top">
      <div class="top-left">
        <module-product-viewer :product="product" :current="currentColorIndex"/>
      </div>
      <div class="top-right">
        <module-product-title :product="product"/>
        <module-product-rate :product="product" v-if="product.reviewCount"/>
        <module-product-info :product="product" :sku="currentSku" @change="handleColorChange"/>
        <module-product-size v-if="isLogin" :product="product" :current-color-index="currentColorIndex" :current-sku="currentSku" @change="handleSizeChange"/>
        <module-product-size-range v-else :product="product" :current-color-index="currentColorIndex"/>
        <module-product-action-button :product="product" :sku="currentSku"/>
        <module-product-description :product="product"/>
        <module-product-suitable-dressing :product="product" :current="currentColorIndex"/>
      </div>
    </div>
    <div class="middle" v-if="fitInfo.reviewCount">
      <div class="title">reviews</div>
      <div class="content">
        <module-product-rate-large :fit-info="fitInfo"/>
        <module-product-reviews :reviews="reviews"/>
      </div>
    </div>
    <div class="bottom">
      <module-carousel-count6-skeleton v-if="isSimilarItemsLoading"/>
      <module-carousel-count6
        v-else-if="!isSimilarItemsLoading && similarItems.length"
        :title="'similar items'"
        :list="similarItems"
      />
      <module-carousel-count6-skeleton v-if="isRecentlyViewedLoading"/>
      <module-carousel-count6
        v-else-if="!isRecentlyViewedLoading && isLogin && recentlyViewed.length"
        :title="'recently viewed'"
        :list="recentlyViewed"
      />
      <module-carousel-count6-skeleton v-if="isYouMayAlsoLikeLoading"/>
      <module-carousel-count6
        v-else-if="!isYouMayAlsoLikeLoading && isLogin && youLike.length"
        :title="'you may also like'"
        :list="youLike"
      />
      <module-carousel-count6-skeleton v-if="isWishListLoading"/>
      <module-carousel-count6
        v-else-if="!isWishListLoading && isLogin && wishlist.length"
        :title="'wishlist'"
        :list="wishlist"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "src/assets/config";

.product-content-mobile {
  .title {
    /* Headline/small */
    font-family: "Alternate Gothic No3 D";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px; /* 133.333% */
    text-transform: uppercase;
    text-align: center;

    margin-top: 24px;
  }

  .footer {
    background-color: white;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1;
    padding: 8px 15px 14px 15px;

    box-shadow: 0px -10px 10px 0px rgba(0, 0, 0, 0.10);
  }
}

.product-content-desktop {
  width: 100%;
  min-width: $content-1280-width;
  padding-top: 32px;

  .top {
    padding: 16px 0;
    margin: 0 auto;
    display: flex;
    gap: 16px;
    width: fit-content;

    .top-left {
    }

    .top-right {
      width: 608px;

      padding-top: 24px;
    }
  }

  .middle {
    width: $content-1280-width;
    padding: 24px 0;
    margin: 0 auto;

    .title {
      /* Headline/small */
      font-family: "Alternate Gothic No3 D";
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px; /* 133.333% */
      text-transform: uppercase;
      text-align: center;
    }

    .content {
      display: flex;
      justify-content: space-between;
      margin-top: 24px;
    }
  }
}

@supports (bottom: env(safe-area-inset-bottom)) {
  .product-content-mobile {
    .footer {
      padding-bottom: calc(env(safe-area-inset-bottom) + 14px);
    }
  }
}
</style>
